import { type BidDto } from "../../../../autogen/bff-api";

export const isBidEditable = (
  bid: Pick<BidDto, "isContentEditable">,
): boolean => bid.isContentEditable === true;
